import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { isMemberBlocked } from 'utils/member-utils';

const MemberPreviewModal = ({ member,gLeader, isOpen, onClose, onEditService }) => {
  if (!isOpen || !member) return null;

  const getAgeGroup = (age) => {
    if(age === "----") return { label: 'N/A', color: 'text-muted-foreground' };
    if (age < 25) return { label: 'Youth', color: 'text-success' };
    if (age < 45) return { label: 'Adult', color: 'text-primary' };
    if (age < 65) return { label: 'Senior', color: 'text-warning' };
    return { label: 'Elder', color: 'text-muted-foreground' };
  };

  const ageGroup = getAgeGroup(member.age);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 modal-backdrop z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg border border-border shadow-spiritual-md max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="User" size={24} className="text-primary" />
            </div>
            <div>
              <h2 className="font-heading font-semibold text-xl text-foreground">
                Member Details
              </h2>
              <p className="text-sm text-muted-foreground">
                Complete information for {member.name}
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            iconName="X"
          />
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {isMemberBlocked(member) && (
            <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-lg flex items-center space-x-2 text-destructive text-sm font-medium">
              <Icon name="AlertCircle" size={18} />
              <span>This member is currently blocked from service participation.</span>
            </div>
          )}

          {/* Personal Information */}
          <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-4 flex items-center space-x-2">
              <Icon name="User" size={18} className="text-primary" />
              <span>Personal Information</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">Full Name</label>
                <p className="text-foreground font-medium">{member.name}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Status</label>
                {isMemberBlocked(member) ? (
                  <p className="inline-flex items-center gap-1 font-semibold text-destructive">
                    <Icon name="AlertCircle" size={14} />
                    Blocked
                  </p>
                ) : (
                  <p className="text-success font-medium">Active</p>
                )}
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Service Point</label>
                <p className="text-foreground font-medium">{member.servicePoint}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Mobile Number</label>
                <p className="text-foreground font-mono">{member.mobNo}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Sai Connect ID</label>
                <p className="text-foreground font-mono">{member.saiOneId}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">District</label>
                <p className="text-foreground">{member.district}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Samithi</label>
                <p className="text-foreground">{member.samithi}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Blod Group</label>
                <p className="text-foreground">{member.bloodGroup}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Age</label>
                <p className={`font-medium ${ageGroup.color}`}>
                  {member.age} years ({ageGroup.label})
                </p>
              </div>
            </div>
          </div>

          {/* Group Leader Information */}

          <div className="bg-muted/30 rounded-lg p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">Leader 1</label>
                <p className="text-foreground font-medium">{gLeader?.leader1?.name || '-------'}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Mobile Number</label>
                <p className="text-foreground font-medium">{gLeader?.leader1?.mobNoPrimary || '-------'}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Leader 2</label>
                <p className="text-foreground font-medium">{gLeader?.leader2?.name || '-------'}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Mobile Number</label>
                <p className="text-foreground font-medium">{gLeader?.leader2?.mobNoPrimary || '-------'}</p>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          {/* <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-4 flex items-center space-x-2">
              <Icon name="Phone" size={18} className="text-primary" />
              <span>Contact Information</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">Mobile Number</label>
                <p className="text-foreground font-mono">{member.mobile}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Email Address</label>
                <p className="text-foreground">{member.email}</p>
              </div>
              <div className="md:col-span-2">
                <label className="text-sm font-medium text-muted-foreground">Address</label>
                <p className="text-foreground">{member.address}</p>
              </div>
            </div>
          </div> */}

          {/* Organizational Information */}
          {/* <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-4 flex items-center space-x-2">
              <Icon name="Building2" size={18} className="text-primary" />
              <span>Organizational Information</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">District</label>
                <p className="text-foreground">{member.district}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Samithi</label>
                <p className="text-foreground">{member.samithi}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Sai Connect ID</label>
                <p className="text-foreground font-mono">{member.saiConnectId}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Role</label>
                <p className="text-foreground">{member.role}</p>
              </div>
            </div>
          </div> */}

          {/* Service Allocation */}
          {/* <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-4 flex items-center space-x-2">
              <Icon name="Briefcase" size={18} className="text-primary" />
              <span>Current Service Allocation</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">Service Point</label>
                <p className="text-foreground font-medium">{member.servicePoint}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Allocation Date</label>
                <p className="text-foreground">{member.allocationDate}</p>
              </div>
              <div className="md:col-span-2">
                <label className="text-sm font-medium text-muted-foreground">Service Description</label>
                <p className="text-foreground">{member.serviceDescription}</p>
              </div>
            </div>
          </div> */}

          {/* Professional Information */}
          {/* <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-4 flex items-center space-x-2">
              <Icon name="GraduationCap" size={18} className="text-primary" />
              <span>Professional Information</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">Qualification</label>
                <p className="text-foreground">{member.qualification}</p>
              </div>
              <div>
                <label className="text-sm font-medium text-muted-foreground">Profession</label>
                <p className="text-foreground">{member.profession}</p>
              </div>
              <div className="md:col-span-2">
                <label className="text-sm font-medium text-muted-foreground">Skills</label>
                <div className="flex flex-wrap gap-2 mt-1">
                  {/* {member.skills.map((skill, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full border border-primary/20"
                    >
                      {skill}
                    </span>
                  ))} */}
                {/*</div>
              </div>
            </div>
          </div> */}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Close
          </Button>
          <Button
            variant="default"
            onClick={() => onEditService(member)}
            iconName="Edit"
            iconPosition="left"
          >
            Edit Service
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MemberPreviewModal;